const Title = Object.freeze({
  QUID_MONITOR: 'Quid Monitor',
  QUID_MONITOR_LIVE_REPORT: 'Quid Monitor Live Report'
})
export default Title
